import React, { Fragment, useState } from 'react';
import { Button } from '@BICE_Vida/components';

import Label from '../../designSystem/Label';
import Select from '../../designSystem/Select';
import Modal from '../../designSystem/Modal';

import styles from './ModalNoUsefulReason.module.scss';

import componentsId from '../../utils/componentsId';
import { modalNoUseFulText } from '../../utils/generalTexts';

const ModalNoUsefulReason = ({ isOpen, closeModal, sendReason }: ModalNoUsefulReasonType) => {
  const initialReason: ReasonFeedback = {
    reasonId: '2',
    reasonDescription: '',
  };

  const [reasonValue, setReasonValue] = useState(initialReason);

  const handleSelectChange = (reasonDescription: string) => {
    const selectedReason = modalNoUseFulText.selectOptions.find(
      (reasonOption) => reasonOption.reasonDescription === reasonDescription
    );

    if (selectedReason !== undefined) {
      setReasonValue(selectedReason);
    }
  };

  const trySaveFeedback = () => {
    sendReason(reasonValue);
    setReasonValue(initialReason);
  };

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        modalClass={styles.modal_container}
        closeOnIcon
        closeOnOverlay
        close={closeModal}
      >
        <div className={styles.modal_parent}>
          <div className={styles.information_content}>
            <img
              src={modalNoUseFulText.icon}
              className={styles.svg}
              alt="queremos seguir mejorando"
            />
            <Label customClass={styles.title_text} text={modalNoUseFulText.title} />
            <Label customClass={styles.subtitle_text} text={modalNoUseFulText.subtitle} />
            <Select
              customClass={styles.selectReason}
              id={componentsId.userQuestionFeedback.reasonSelection}
              placeholder={modalNoUseFulText.selectPlaceholder}
              options={modalNoUseFulText.selectOptions.map((reason) => reason.reasonDescription)}
              onChange={handleSelectChange}
            />
          </div>
          <div>
            <Button
              text={modalNoUseFulText.buttonText}
              variant="primary"
              disabled={reasonValue.reasonId.length <= 0}
              onClick={trySaveFeedback}
            />
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

type ModalNoUsefulReasonType = {
  isOpen: boolean;
  closeModal: () => void;
  sendReason: (reason: ReasonFeedback) => void;
};

export default ModalNoUsefulReason;
